export default "__VITE_ASSET__BncwMKWk__"